import axios from 'axios'

axios.interceptors.request.use(async (config) => {
  const accessToken = localStorage.getItem('access_token')

  if (accessToken != null && !config.url.includes('api/identity/auth')) {
    config.headers = { Authorization: `Bearer ${accessToken}` }
  }
  return config
})

export const axiosInterceptors = axios
